import React from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';

export default function LocationPrompt({ onRetry, onCheck, isBlocked }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/30 backdrop-blur-sm flex items-center justify-center">
      <div className="bg-white rounded-2xl p-6 shadow-lg max-w-sm w-full text-center">
        <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-soft text-primary text-2xl">
          <FaMapMarkerAlt />
        </div>

        <h2 className="text-xl font-semibold mb-2">
          {isBlocked ? 'Location Blocked' : 'Enable Location Access'}
        </h2>

        {isBlocked ? (
          <>
            <p className="text-gray-600 mb-4 text-sm">
              Location access is <strong>blocked</strong> in your browser settings.
              <br />
              To continue, please enable location manually for this site:
            </p>
            <ul className="text-sm text-left list-disc pl-6 text-gray-500 mb-4">
              <li>Click the lock 🔒 icon in your browser’s address bar</li>
              <li>Find “Location” and change it to “Allow”</li>
              <li>Then refresh this page or click the button below</li>
            </ul>
          </>
        ) : (
          <p className="text-gray-600 mb-6 text-sm">
            This app needs your location to tag device installs.
          </p>
        )}

        <button
          onClick={onRetry}
          disabled={isBlocked}
          className={`w-full py-2 rounded-xl font-medium transition ${
            isBlocked
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'bg-primary text-white hover:bg-primary/90'
          }`}
        >
          {isBlocked ? 'Blocked by Browser' : 'Retry'}
        </button>

        {isBlocked && (
          <button
            onClick={onCheck}
            className="mt-3 w-full bg-primary text-white py-2 rounded-xl text-sm font-medium hover:bg-primary/90"
          >
            I’ve Enabled Location
          </button>
        )}
      </div>
    </div>
  );
}
